// extracted by mini-css-extract-plugin
export default {"bold":"EUW690Rbm_0IQdIZRV95"};